<mat-card appearance="outlined" class="card-margin">
  <div mat-dialog-content>
      <div class="md-title header" class="title-padding">{{headLine}}</div>
        <mat-form-field>
          <mat-label>Contact Name</mat-label>
          <input matInput
                 [value]="contactObj?.firstName + ' ' + contactObj?.lastName"
                 disabled
                 name="external_contact_detail_contactName"/>
        </mat-form-field>
        <div fxLayout="row">
          <mat-form-field>
            <mat-label>Phone</mat-label>
            <input matInput
                   value="{{contactObj?.phoneNumber | phoneNumber}}"
                   disabled
                   name="phoneNumber"/>
          </mat-form-field>
          <mat-form-field fxFlexOffset="5">
            <mat-label>Fax</mat-label>
            <input matInput
                   value="{{contactObj?.faxNumber | phoneNumber}}"
                   disabled
                   name="faxNumber"/>
          </mat-form-field>
        </div>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput
               [value]="contactObj && contactObj.email ? contactObj.email : ''"
               uiInputHref="mailto:{{contactObj?.email}}"
               readonly
               name="email"/>
      </mat-form-field>
      <div fxLayout="row">
        <mat-form-field>
          <mat-label>Svc Req K</mat-label>
          <input matInput
                 [value]="contractId"
                 name="contractId"
                 disabled/>
        </mat-form-field>
        <mat-form-field fxFlexOffset="5">
          <mat-label>{{baLabel}}</mat-label>
          <input matInput
                 [value]="contactObj?.dunsNbr"
                 disabled
                 name="dunsNbr"/>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>{{baLabel}} Name</mat-label>
        <input matInput
               [value]="contactObj?.baName"
               disabled
               name="baName"/>
      </mat-form-field>
  </div>
</mat-card>
